import { useSelector } from 'react-redux';
import { formatStatisticalNumberOutput, getStatePropertyItemsCount } from '@helpers/customerHelpers';

export function useFavoritesCount() {
    const favorites = useSelector(state => state.favorites);
    const count = getStatePropertyItemsCount(favorites.products);
    const formattedCount = formatStatisticalNumberOutput(count);

    return formattedCount;
}
